// extracted by mini-css-extract-plugin
module.exports = {"HeavyShippingMessage":"heavyShippingMessage_HeavyShippingMessage__8iCtG"};